import './bootstrap';
import 'jquery.cookie';
// Local
//import './local/console.js';
import './local/jquery.fancybox';
import './local/jquery.fancybox-thumbs';
import './local/jquery.validate.min.js';
import './local/jquery.metadata.js';
import 'superfish/dist/js/superfish'
import 'superfish/dist/js/supersubs'
import 'superfish/dist/js/hoverIntent'

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import './wwdev/search';
// import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
// import '@wwdev/myaccount/index.js';
// import '@wwdev/register';
// import '@wwdev/search';
import '@wwdev/product/index'
import '@wwdev/functions/setEqualHeightsPerRow';
import './externals/hamburgers.js';


// import './modules/ShoppingCart';
// import './extern/modernizr'

import './extern/wwdev.extender';
import './extern/easing'
import './extern/bs'
import './extern/bxslider'
import './extern/input-clear'
import './extern/range-slider'
import './extern/jquery.zoom'
import './extern/bookblock'
import './extern/custom'
import './extern/social'
import './extern/jquery.booklet.latest'

// import './default';
import './base/whatsapp';
import './base/default.js';

import './wwdev/cookiebar/index';


// Vendor
import './vendor/Product/LetterFilter'

import Filters from './vendor/Product/overview-filter';

new Filters();
